// extracted by mini-css-extract-plugin
export var legal = "SeeDetailsModal_legal__45rZf";
export var md = "768px";
export var modalContainer = "SeeDetailsModal_modalContainer__HfMKc";
export var modalOverlay = "SeeDetailsModal_modalOverlay__oySM5";
export var modalWrapper = "SeeDetailsModal_modalWrapper__RP9si";
export var shared = "'../../shared.module.css'";